import { createAPIModule } from 'utility/redux/apiModuleHelpers';

const getStateSlice = (state) => state.api.network.private.get;

const { actions, reducer, sagas, selectors } = createAPIModule({
	getStateSlice,
	actionType: 'NETWORK_PRIVATE_GET',
	url: '/network/private/get.json',
});

export { actions, reducer, sagas, selectors };
